import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { ApiRouteWorkShiftService } from '../../../../api/elite/routes/work-shift.service';

export type QualityControlCreateInspectionTypes = {
  data: DataType;
  result: ResultType;
};

type DataType = {
  maxQuantity: number;
  minQuantity: number;
  inspectionStage?: string;
  shifts: { id: number; title: string }[];
  department?: string;
};
type ResultType = {
  success: boolean;
  quantity: number;
  details?: {
    shiftId: number;
    inspectionStage: string;
  };
};

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatSelectModule,
  ],
  templateUrl: './create-inspection.component.html',
  styleUrls: ['./create-inspection.component.sass'],
})
export class QualityControlCreateInspectionComponent implements OnInit {
  minQuantity = this.data.minQuantity ?? 5;

  form = new FormGroup({
    quantity: new FormControl<number>(undefined, [
      Validators.required,
      Validators.min(this.minQuantity),
    ]),
    shift: new FormControl<number>(undefined),
  });

  shifts = this.data.shifts || [];
  showShifts = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: DataType,
    private readonly apiShiftRouter: ApiRouteWorkShiftService
  ) {}

  ngOnInit(): void {
    if (this.data.inspectionStage && this.shifts.length === 0) {
      this.apiShiftRouter.all(this.data.department).subscribe((res) => {
        this.shifts = res;
      });
    }
    if (this.data.inspectionStage || this.shifts.length > 0) {
      this.showShifts = true;
      this.form.get('shift').setValidators([Validators.required]);
    }
  }

  onClickClose(): void {
    this.dialogRef.close();
  }

  onClickSave(): void {
    if (this.form.invalid) {
      return;
    }
    this.dialogRef.close({
      quantity: this.form.get('quantity').value,
      success: true,
      details: {
        shiftId: this.form.get('shift').value,
        inspectionStage: this.data.inspectionStage,
      },
    });
  }
}
